import { motion } from 'framer-motion';
import animations from 'utils/animations';
import Seo from 'components/Seo';
import AnimationPage from 'components/AnimationPage';
import "assets/styles/OurValues.css";

export default function OurValues() {
  const { principles } = require('data/our-values.json');
  const { opacity, opacityAndSlide } = animations.components;

  return (
    <AnimationPage>
      <Seo title="Our Values - Kollectiff" />
      <main>
        <div className="container our-values">
          <motion.h1
            className='k-title-sm md:k-title-md lg:k-title-lg'
            {...opacity}
            transition={{ delay: .2 }}>
            Our Values
          </motion.h1>
          <div className="our-values-list">
            {principles.map(principle =>
              <motion.div 
                {...opacityAndSlide}
                transition={{ delay: .3 }}
                key={principle.title} 
                className="value-item">
                <h2 className='k-title-xs lg:k-title-sm'>{principle.title}</h2>
                <p className="k-text-lg font-semibold">{principle.subtitle}</p>
                <p className='k-text-md'>{principle.description}</p>
              </motion.div>
            )}
          </div>
        </div>
      </main>
    </AnimationPage>
  );
}
